import type { Post } from '@/@types/post'
import day from '@/utils/day'
import { css } from '@emotion/react'
import { Link } from '@tanstack/react-router'
import type { HTMLAttributes } from 'react'
import Avatar from '../Avatar'
import ScreenNames from '../ScreenNames'
import PostHeader from './PostHeader'
import UserCard from './PostTargetCard/UserCard'

export interface UserFollowPostProps extends HTMLAttributes<HTMLDivElement> {
	data: Post | undefined
}

export default function UserFollowPost({ data, ...props }: UserFollowPostProps) {
	if (!data) {
		return null
	}
	const { users, createdAt, targetUsers } = data
	const targetUser = targetUsers?.[0]

	return (
		<div
			css={css`
				display: grid;
				grid-template-columns: auto 1fr;
				gap: 10px;
				padding: 20px 15px;
			`}
			{...props}
		>
			<Avatar
				data={users?.[0]}
				css={css`
					margin: 4px 0;
				`}
			/>

			<div
				css={css`
					display: flex;
					flex-direction: column;
				`}
			>
				<PostHeader
					title={
						<div
							css={css`
								display: grid;
								grid-template-columns: auto 1fr;
								gap: 4px;
							`}
						>
							<ScreenNames data={users ?? []} />
							<span
								css={css`
									color: var(--tint-secondary);
								`}
							>
								关注了即友
							</span>
						</div>
					}
					desc={day(createdAt).fromNow()}
				/>
				{targetUser && (
					<div
						css={css`
							margin-top: 10px;
						`}
					>
						<Link
							to="/u/$username"
							params={{
								username: targetUser.username,
							}}
							data-clickable-feedback
						>
							<UserCard data={targetUser} />
						</Link>
					</div>
				)}
			</div>
		</div>
	)
}
